import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface DeletePyramidDialogData {
  itemName: string;
  currentYear: number;
  allYears: number[];
  hideDeleteCurrentYear?: boolean;
}

export interface DeletePyramidDialogResult {
  deleteAll: boolean;
  selectedYears?: number[];
}

@Component({
  selector: 'app-delete-pyramid-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './delete-pyramid-dialog.component.html',
  styleUrls: ['./delete-pyramid-dialog.component.scss']
})
export class DeletePyramidDialogComponent {
  selectedYears: Set<number> = new Set();

  constructor(
    public dialogRef: MatDialogRef<DeletePyramidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeletePyramidDialogData
  ) {
    // Initialize with no years selected by default
  }

  toggleYearSelection(year: number): void {
    if (this.selectedYears.has(year)) {
      this.selectedYears.delete(year);
    } else {
      this.selectedYears.add(year);
    }
  }

  isYearSelected(year: number): boolean {
    return this.selectedYears.has(year);
  }

  selectAllYears(): void {
    if (this.data.allYears) {
      this.data.allYears.forEach(year => this.selectedYears.add(year));
    }
  }

  deselectAllYears(): void {
    this.selectedYears.clear();
  }

  get hasSelectedYears(): boolean {
    return this.selectedYears.size > 0;
  }

  get selectedYearsCount(): number {
    return this.selectedYears.size;
  }

  onDeleteCurrentYear(): void {
    this.dialogRef.close({
      deleteAll: false,
      selectedYears: [this.data.currentYear]
    });
  }

  onDeleteAllYears(): void {
    this.dialogRef.close({
      deleteAll: true,
      selectedYears: this.data.allYears
    });
  }

  onDeleteSelectedYears(): void {
    this.dialogRef.close({
      deleteAll: false,
      selectedYears: Array.from(this.selectedYears)
    });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
